<template>
    <div class="payment__card mt-5">
        <h3 class="payment__card-title" v-text="'Dokumenty rozliczeniowe'" />

        <div v-if="documents.length" class="payment-documents c-table">
            <div class="c-thead">
                <div v-text="'Numer dokumentu'" class="c-td is-1" />
                <div v-text="'Termin płatności'" class="c-td is-2" />
                <div v-text="'Status dokumentu'" class="c-td is-3" />
                <div v-text="'Kwota netto'" class="c-td is-4" />
                <div v-text="'Wartość VAT'" class="c-td is-4" />
                <div v-text="'Kwota brutto'" class="c-td is-4" />
                <div v-text="'Raport'" class="c-td is-5" />
                <div v-text="'Faktura VAT'" class="c-td is-5" />
                <div v-text="'Płatność'" class="c-td is-6" />
            </div>
            <div class="c-tbody">
                <payment-document-row
                    v-for="doc in documentsPaginated"
                    :key="doc.id"
                    :doc="doc"
                />
            </div>
            <div class="c-tfooter">
                <results-dropdown
                    :per-page="pagination.perPage"
                    :options="[10, 20, 50, 100]"
                    :on-change="changePerPage"
                />
                <the-pagination
                    :pagination="pagination"
                    @change="changePage"
                />
            </div>
        </div>

        <div v-else v-text="'Brak wyników'" />
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
    async created() {
        // set documents pagination
        if (this.documents.length) {
            const perPage = this.pagination.perPage
            const totalPages = Math.ceil(this.documents.length / perPage)

            this.setDocumentsPagination({
                totalPages,
                perPage,
                page: 1,
                prevPage: null,
                nextPage: totalPages > 1 ? 2 : null
            })
        }
    },

    computed: {
        ...mapGetters('payment', {
            documents: 'documents',
            pagination: 'documentsPagination'
        }),

        documentsPaginated() {
            const { page, perPage } = this.pagination
            const documents = this.documents

            if (documents.length <= perPage) {
                return documents
            }

            const start = (page - 1) * perPage
            const end = start + perPage

            return documents.slice(start, end)
        }
    },

    methods: {
        ...mapActions('payment', ['setDocumentsPagination']),

        changePerPage(val) {
            const totalPages = Math.ceil(this.documents.length / val)

            this.setDocumentsPagination({
                totalPages,
                perPage: val,
                page: 1,
                prevPage: null,
                nextPage: totalPages > 1 ? 2 : null
            })
        },
        changePage(page) {
            this.setDocumentsPagination({
                ...this.pagination,
                page,
                prevPage: page > 1 ? page - 1 : null,
                nextPage: page < this.pagination.totalPages ? page + 1 : null
            })
        }
    }
}
</script>

<style lang="scss">
@import '@/styles/_custom.scss';
@import '~bootstrap/scss/mixins';

.payment-documents {
    .c-tr .typo-label {
        display: none;
    }
    .is-1, .is-2, .is-3 {
        flex: 0 0 9rem;
        min-width: 9rem
    }
    .is-2, .is-3, .is-4 {
        text-align: center;
    }
    .is-3 {
        max-width: 9rem;
    }
    .is-5 {
        padding-right: 1rem;
        flex: 0 0 7.5rem;
        min-width: 7.5rem;
    }
    .is-6 {
        flex: 0 0 10.5rem;
        min-width: 10.5rem;
    }
    .is-5, .is-6 {
        button {
            width: 100%;
        }
    }

    @include media-breakpoint-down(lg) {
        .c-tr {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            padding: 1rem;

            .c-td {
                padding: 0.5rem;
                .typo-label {
                    display: flex;
                    margin-bottom: 0.25rem;
                }
            }

            .is-2, .is-3, .is-4 {
                text-align: start;
            }
        }
        .c-thead {
            display: none;
        }
    }
    @include media-breakpoint-down(sm) {
        .c-tr {
            grid-template-columns: repeat(2, 1fr);
        }
    }

    @include media-breakpoint-down(xs) {
        .c-tr {
            display: flex;
            .c-td {
                flex: 0 0 auto;
            }
        }
    }
}
</style>